import { SLAddAddressFormLabels } from './ServiceLocation'
export enum AddAddressFormDataLabels {
	AddressType = 'addressTypeId',
	Contact = 'contactId',
	AddressLine1 = 'addressLine1',
	AddressLine2 = 'addressLine2',
	City = 'city',
	StateProvince = 'stateProvinceId',
	ZipCode = 'zipCode'
}

export type SLAddAddressFormDataLabelsType = AddAddressFormDataLabels | SLAddAddressFormLabels

export enum TaxesLabels {
	UsTaxRate = 'usTaxRate',
	StateTaxRate = 'stateTaxRate',
	CityTaxRate = 'cityTaxRate',
	CountyTaxRate = 'countyTaxRate',
	MtaTaxRate = 'mtaTaxRate',
	SpdTaxRate = 'spdTaxRate',
	Other1TaxRate = 'other1TaxRate',
	Other2TaxRate = 'other2TaxRate',
	Other3TaxRate = 'other3TaxRate',
	Other4TaxRate = 'other4TaxRate',
	other1Name = 'other1Name',
	other2Name = 'other2Name',
	other3Name = 'other3Name',
	other4Name = 'other4Name'
}

export enum ValidateAddressFormFields {
	AddressLine1 = 'addressLine1',
	StateProvince = 'stateProvinceId',
	City = 'city',
	ZipCode = 'zipCode',
	Latitude = 'latitude',
	Longitude = 'longitude',
	AddressLine2 = 'addressLine2'
}

export enum LessonStatus {
	hundred = '100',
	overdue = 'overdue',
	complete = 'complete'
}

export declare namespace Miscellaneous {
	interface StateProvince extends Entity {
		code: string | null
		countryCode: string | null
		region: string | null
	}

	interface Taxes {
		[TaxesLabels.UsTaxRate]: Key | null
		[TaxesLabels.StateTaxRate]: Key | null
		[TaxesLabels.CityTaxRate]: Key | null
		[TaxesLabels.CountyTaxRate]: Key | null
		[TaxesLabels.MtaTaxRate]: Key | null
		[TaxesLabels.SpdTaxRate]: Key | null
		[TaxesLabels.Other1TaxRate]: Key | null
		[TaxesLabels.Other2TaxRate]: Key | null
		[TaxesLabels.Other3TaxRate]: Key | null
		[TaxesLabels.Other4TaxRate]: Key | null
		[TaxesLabels.other1Name]: string | null
		[TaxesLabels.other2Name]: string | null
		[TaxesLabels.other3Name]: string | null
		[TaxesLabels.other4Name]: string | null
	}

	interface ValidateAddress {
		city: string
		state: StateProvince
		zipCode: string
		latitude: number
		longitude: number
		addressLine1: string
	}

	interface ValidateAddressParams {
		stateId: number
		zipCode: string
		cityName: string
		addressLine1: string
	}

	interface ValidateAddressForm {
		[ValidateAddressFormFields.AddressLine1]: BasicString
		[ValidateAddressFormFields.AddressLine2]: BasicString
		[ValidateAddressFormFields.City]: BasicString
		[ValidateAddressFormFields.StateProvince]: LabelValueExtra | null
		[ValidateAddressFormFields.ZipCode]: BasicString
		[ValidateAddressFormFields.Latitude]?: Key | null
		[ValidateAddressFormFields.Longitude]?: Key | null
	}

	namespace ServiceSites {
		interface Response {
			searchResultById: Entity[]
			searchResultByName: Entity[]
		}
	}
	namespace UnitOfMeasure {
		interface Rates {
			fromUnit: Entity
			toUnit: Entity
			rate: number
		}
	}

	namespace ProcessingCenter {
		interface City extends Entity {
			city: string
		}

		interface State extends Entity {
			state: {
				name: string
				code: string
				region: string
			}
		}

		interface Address extends Entity {
			addressLine1: string
			addressLine2: string
		}
	}
}

export interface Region extends Entity {
	states: Miscellaneous.StateProvince[]
}
